
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"id":"image0","width":"32","height":"27","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL6SURBVHgB7VXNS1RRFD/nvjfTOGOaY+ZHkzNSVhREIbWtTdCuRZAuKhCj2UR/QG1aBlEUrYpoGzFgi6BoEWTbog+ihSKZOONopPahzte793Tu8LAc330+wU3kgR/3vXvPOb/f/ToXYMP+d8OgjlcBxEBid3uUFMZzh/IIGVnrQ/cb4sVKtKEgSnPx9NyPIHlXFZBvS6WUsK+w51ECaOIum/GV8UQoeac9PTZR6kxcRKBeAtzF/WEgLICgt0R0M/IsN4QZkGsWwGSYa+++wIlu8G/MMzhMxcYzzrTdJZNgtsFNlWwfpqGyJgETie5TQqlHhGh5BtqkIj1EoW0gQjsdic3KBvNkHkbmI/14abRUOya8AqaSyS4kumUi12Z3AtnNYJEErHyxgSrm3eSRvmKs0Os15ilAypB2ToCRnVQ4SUu/VOaeGTTus9YgBKbf3O0JBRJAhIfBx6zNqEQdLFsdOSuUXwwpOLjfmuyo7TfsG8XBx0SUVsSRgyG/GN6HqLStxhW5vHyJvE/s0ngFlAfBakahCqpgApA+g1+mRU5UkwojygF/y4axMB5IgEXWSz5ixoRyAYT8vqy4kGhVxhtTFYj0Age+/QokoGNyJMPNKzAZgSiPCCIHqldBNCtpNZC5qCHmeU9ve415CuBMfLuL57h9BwZzZsEuD/NWxJSyk1KAWewil+nz9f2594EFaNuRzeb4NJ7kT70a5RV5CZzSuMhYKecyhGnWmxs/KVTHI/3ZpyaeQK9hvm1vSlryBKc8wMQ2CPzIlfJxIjearRJdb42VmiLHACU/WNjCzDklxGC0/sgHPJ2RsN7Gr1wdY98a/PcwtnuN2T5B17jZwtA1YYyhi1Mdo5PxgHGWfYa57WG8BqjeCu2vt6OesZWxmTHlxt1j5Gp5zIcH4CfjOWOIodXnGXOMIkM/v9OMFpdckw7+FZt3J6dvkq6QMyYS9FmBKPypBY47u3l3ZnpWja5IPdsCIpY5Ju726XbBjdMcYf3PPut/Hjbsn7ffB+EhazjuZYwAAAAASUVORK5CYII="}})])
          )
        }
      }
    